export { default as default } from './BlocDeContingutsWrapper';
